import LzDialog from '@/components/common/LzDialog';
import style from "./index.module.scss";
import React, { useEffect, useRef, useState } from 'react';
import { Balloon, Button, Input, Loading, Radio, Select} from '@alifd/next';
import { Servlets } from '@/service';
import Text from './Text';
import LzMsg from '@/components/common/LzMsg';
import CONSTANTS from '@/utils/constant';
import UUID from '@/utils/UUID';
import SelectGoods from '@/components/CrowdTagSelectGoodProductId/index';
import InsertCoupon from './InsertCoupon';
const ADDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3;
const CN_NTC_ADDLENGTH = 2; // 通知类短信没有拒收请回复R
const TYPE_LIST= {
  '会员中心页':1,
  '达人主页':2,
  '店铺首页':3,
  '商品详情页':4,
  '订单详情页':5,
  '优惠券链接':6,
  '店铺7分屏':7,
  '直播间':8,
}
function CreateSmsTemplate(props) {
  const {dialogVisible, setDialogVisible, setRefreshList} = props;
  const childRef = useRef();
  const [clickTag, setClickTag] = useState({ key: '', value: '' });// 点击标签添加的链接
  const [sizeLength, setSizeLength] = useState(0);// 已输入字数
  const [everyMessageNum, setEveryMessageNum] = useState(1);// 每条短信算几条
  const [sign, setSign] = useState(''); // 短信签名
  const [smsTypeDataSource, setSmsTypeDataSource] = useState([]);
  const [currentSmsTypeData, setCurrentSmsTypeData] = useState();//模板类型下拉列表数据
  const [currentParamsList, setCurrentParamsList] = useState();//当前的插入变量数据
  const [phoneMessage,setPhoneMessage] = useState('');//右侧实时预览文案
  const [goodsVisible, setGoodsVisible] = useState(false); //选择商品组件
  const [couponVisible, setCouponVisible] = useState(false); //输入优惠券ID组件
  const [textLoading,setTextLoading] = useState(false);//短信输入框loading
  const [templateParams,setTemplateParams] = useState({
    isOfficial: 0,      //"是否是系统模板 1-是 0-否"
    templateName:'',    // "短信模版名称"
    templateContent:'', // "短信模板内容"
    channelType:'',
    modelTypeCode:'',
    templateShowContent:'',
  });
  // 点击标签添加变量
  const handleClickParams = (v) => {
    setClickTag({ key: UUID.getUUID32(), value: v.name });
  };
  // 点击标签添加链接
  const handleClickLink = (v) => {
    setTextLoading(true);
    Servlets('getSmsShortLink',{type:TYPE_LIST[v.name],productId:v.productId || '',couponId:v.couponId || ''}).then((res) => {
      if(res.data){
        setClickTag({ key: UUID.getUUID32(), value: res.data.linkUrl });
        setTextLoading(false);
      }
    }).catch((e) => {
      console.log(e);
      setTextLoading(false);
    })
  };
  // 自定义的文本域
  const tagTextAreaChange = (value) => {
    setTemplateParams({ ...templateParams, templateContent: value });
    // setTestParams({ ...testParams, fullContent: value });

    // 用占位符替换算字数，第一次敲回车键会加两次字数，清掉一次回车键
    let str = value;
    const lastCharacter = str?.substr(str.length - 1, 1); // 最后1个字符,
    if ('\n'.includes(lastCharacter)) {
      // 如果是回车
      str = str.replace(/\n$/, ''); // 会多一个\n，需要清掉最后一个\n
    }
    // 要把链接tag换成对应个数的@
    str = str
      ?.replace(/\n/, '@')
      .replace(/#[^#]+#/g, (word) => {
        const obj = currentParamsList.find((item) => `#${item.name}#` === word);
        return new Array(obj?.wordNum).fill('@').join('');
      });
    setSizeLength(str?.length + sign?.length + ( templateParams.channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH));
  };
  const getSmsTypeInfo = () => {
    Servlets('smsModelType',{}).then((res) => {
      if(res.data){
        setSmsTypeDataSource(res.data);
        setTemplateParams({
          ...templateParams,
          channelType:res.data[0].channelType,
          modelTypeCode:res.data[0].typeList[0].typeCode,
        });
        setCurrentSmsTypeData({...res.data[0]});
        setCurrentParamsList({...res.data[0]}.typeList[0].paramList);
      }
    }).catch((e) => {
      console.log(e);
    })
  }
  const getSign = () => {
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        setSign(res.data);
        setSizeLength(res.data.length + ( templateParams.channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH));
      }).catch((e) => {
        console.log(e);
      });
    });
  }
  const confirm = () => {
    let newTemplateParams = {...templateParams}
    if(newTemplateParams.templateName==='') {
      LzMsg.error('模板名称不能为空!');
      return false
    }
    if(newTemplateParams.templateContent==='') {
      LzMsg.error('短信内容不能为空!');
      return false
    }
    if(sizeLength>350){
      LzMsg.error('短信内容过长，请重新编辑文案');
      return false
    }
    const obj = {};
    currentParamsList.forEach((item) => {
      obj[item.code] = `#${item.name}#`;
    });
    for (const key in obj) {
      const value = obj[key];
      newTemplateParams.templateContent = newTemplateParams.templateContent.replace(new RegExp(value, 'g'), key);
    }

    let params = {
      ...newTemplateParams,
      templateContent:newTemplateParams.templateContent ?`${newTemplateParams.templateContent}${templateParams.channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`:'',
      templateShowContent:templateParams.templateContent?`${templateParams.templateContent}${templateParams.channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`:'',
      contentLength:sizeLength||0,
      smsSplitNum:everyMessageNum||1,
    }
    Servlets('applyTemplate', params).then((res: any) => {
      console.log('res', res);
      if (!res.success) {
        LzMsg.error(res.resp_msg);
      } else if(res.data){
        LzMsg.success('提交成功！');
        setRefreshList(true);
        setDialogVisible(false);
        setClickTag({ key: '', value: '' });
      }
    }).catch((e) => {
      console.log('edddddd', e);
      LzMsg.error('提交失败！');
      setDialogVisible(false);
      setClickTag({ key: '', value: '' });
    })
  }
  const changeTypeDefault = (channelType)=>{
    setClickTag({ key: '', value: '' });
    childRef.current.cleanText();
    setEveryMessageNum(1);
    setSizeLength(sign.length + ( channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH));
    setPhoneMessage(`【${sign}】${ channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`);
  }
  const cancel = () => {
    setDialogVisible(false);
    setClickTag({ key: '', value: '' });
    setTemplateParams({
      isOfficial: 0,      //"是否是系统模板 1-是 0-否"
      templateName:'',    // "短信模版名称"
      templateContent:'', // "短信模板内容"
      channelType:'',
      modelTypeCode:'',
      templateShowContent:'',
    });
  }
  // 70字一条，超过70字每67字一条
  const everyCheck = (nowText) => {
    let tempCount = 1;
    const len = nowText ? nowText : sizeLength;
    if (+len <= 70 && len !== 0) {
      tempCount = Math.ceil(+len / 70);
    } else if (+len > 70) {
      tempCount = Math.ceil(+len / 67);
    }
    setEveryMessageNum(tempCount);
  };
  // 计算条数
  useEffect(() => {
    everyCheck(sizeLength);
  }, [sizeLength])
  useEffect(()=>{
    getSign();
  },[sign])
  useEffect(()=>{
    const cancelWord = `${templateParams.channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`
    let showMessage = templateParams.templateContent ?`【${sign}】${templateParams.templateContent}${cancelWord}` :`【${sign}】${cancelWord}`
    setPhoneMessage(showMessage);
  },[sign,templateParams.templateContent]);
  useEffect(()=>{
    getSmsTypeInfo();
  },[])
  return (
    <LzDialog
      visible={dialogVisible}
      title="新建短信模板"
      isFullScreen
      onClose={cancel}
      shouldUpdatePosition
      style={{ width: 1060 }}
      footer={
        <div>
          <Button
            type='primary'
            onClick={()=>{confirm()}}
            style={{paddingLeft:'19px'}}
            className={`${style.w88} ${style.mr10}`}
          >
            提交审核
          </Button>
          <Button
            type='normal'
            onClick={cancel}
            className={style.w88}
          >
            取消
          </Button>
        </div>
      }
    >
      <div className={style['big-box']}>
        <div className={style['left-box']}>
          <div className={style['params-box1']}>
            <div className={style['title-box']}><span className={style['red-text']}>*</span>模板名称：</div>
            <Input
              name='templateName'
              placeholder='请输入模板名称'
              value={templateParams.templateName}
              showLimitHint
              maxLength={32}
              style={{width:'500px'}}
              onChange={(v)=>{setTemplateParams({...templateParams,templateName:v})}}
            />
          </div>
          <div className={style['params-box2']}>
            <div className={style['title-box']}><span className={style['red-text']}>*</span>短信类型：</div>
            <div>
              <Radio.Group
                direction={'hoz'}
                value={templateParams.channelType}
                onChange={(v)=>{
                  let currentChooseChannelData = smsTypeDataSource.filter((item)=>{return item.channelType === v })[0]
                  setTemplateParams({...templateParams,channelType:v,modelTypeCode:currentChooseChannelData.typeList[0].typeCode});
                  setCurrentParamsList(currentChooseChannelData.typeList[0].paramList)
                  setCurrentSmsTypeData(currentChooseChannelData);
                  changeTypeDefault(v);
                }}
              >
                {
                  smsTypeDataSource.map((item, index)=>{
                    return (
                      <Radio value={item.channelType} key={item.channelType} >{item.channelName}</Radio>
                    )
                  })
                }
              </Radio.Group>
              <div style={{marginTop:'5px'}}>
                <Balloon.Tooltip align='br' popupStyle={{maxWidth:'950px'}} v2 trigger={<Button text type='primary'> &gt;&gt; 查看【营销短信】和【通知短信】对比</Button>}>
                  <img width={900} src='//img10.360buyimg.com/imgzone/jfs/t1/156260/39/47545/45627/66ece55aF0f7b6af6/fef359cad91d059d.png' alt='短信类型介绍'/>
                </Balloon.Tooltip>
              </div>
            </div>
          </div>
          <div className={style['params-box1']}>
            <div className={style['title-box']}><span className={style['red-text']}>*</span>模板类型：</div>

            <Select
              value={templateParams.modelTypeCode}
              style={{width:'300px'}}
              onChange={(v)=>{
                setTemplateParams({...templateParams,modelTypeCode:v});
                setCurrentParamsList(currentSmsTypeData.typeList.filter((item)=>{return item.typeCode === v })[0].paramList)
                changeTypeDefault(templateParams.channelType);
              }}
            >
              {
                currentSmsTypeData && currentSmsTypeData.typeList && currentSmsTypeData.typeList.map((item)=>{
                  return (
                    <Select.Option value={item.typeCode} key={item.typeCode}>{item.typeName}</Select.Option>
                  )
                })
              }
            </Select>
          </div>
          <div className={style['params-box1']}>
            <div className={style['title-box']}>
              插入变量：
            </div>
            <div className={style['insert-params-box']}>
              {
                currentParamsList && currentParamsList.map((item)=>{
                  return (
                    // <Balloon.Tooltip
                    //   key={item.typeCode}
                    //   trigger={
                        <Button
                          size='small'
                          type='secondary'
                          style={{borderRadius:'4px'}}
                          disabled={item.disable}
                          onClick={() => handleClickParams(
                            {
                              ...item,
                              name:`#${item.name}#`
                            }
                          )}
                        >
                          {item.name}
                        </Button>
                    //   }
                    // >
                    // </Balloon.Tooltip>
                  )
                })
              }
            </div>
          </div>
          <div className={style['params-box1']}>
            <div className={style['title-box']}>插入链接：</div>
            <div className={style['insert-params-box']}>
              {
                currentSmsTypeData && currentSmsTypeData.typeList.filter((item)=>{return item.typeCode === templateParams.modelTypeCode })[0].linkList.map((item)=>{
                  return (
                    // <Balloon.Tooltip
                    //   key={item.name}
                    //   trigger={
                        <Button
                          size='small'
                          type='secondary'
                          style={{borderRadius:'4px'}}
                          disabled={item.disable}
                          onClick={() =>  {
                            if(item.name==='商品详情页') {
                              setGoodsVisible(true);
                            }else if(item.name==='优惠券链接') {
                              setCouponVisible(true);
                            }else {
                              handleClickLink(item);
                            }
                          }}
                        >
                          {item.name}
                        </Button>
                    //   }
                    // >
                    // </Balloon.Tooltip>
                  )
                })
              }
            </div>
          </div>
          <div className={style['params-box2']}>
            <div className={style['title-box']}><span className={style['red-text']}>*</span>短信内容：</div>
            <div>
              <Loading visible={textLoading}>
                <div style={{maxWidth:'600px'}}>
                  <Text
                    cRef={childRef}
                    clickTag={clickTag}
                    defaultValue={templateParams.templateContent}
                    onChange={tagTextAreaChange}
                  />
                </div>
              </Loading>
              <div className={style['gary-box']}>
                <div className={style['left-box']}>
                  <div>
                    已输入：
                    <span className={style['red-text']}>
                      {sizeLength}
                    </span>
                    /350字
                  </div>
                  {
                    templateParams.channelType !== 'CN_NTC' && <div>（包含签名“{CONSTANTS.LZ_SMS_CANCEL_WORD}”）</div>
                  }
                  <div>
                    当前计费：
                    <span className={style['red-text']}>
                      {everyMessageNum}
                    </span>
                    条
                  </div>
                </div>
                <div className={style['gary-right-box']}>
                  <Balloon.Tooltip
                    trigger={<Button text type='primary' style={{marginRight:'5px'}}>内容规范</Button>}
                    align={"t"}
                  >
                    <div className={style['tips-box']}>
                      <div>1、请您避免在短信正文中使用“￥、*、&、v、※、【】”等特殊字符，可能会导致短信出现乱码。</div>
                      <div>2、在短信签名和店铺名称中不得使用dy/抖音的字眼，且短信内容中不得有抖音字眼会误导公众任为是抖音发送的短信。</div>
                      <div>3、短信内容里不允许出现，POS机、代开发票、金融、毒品、赌博、众筹、慈善捐、股票、移民、面试招聘、彩票、返利、贷款、催款、投资理财、中奖、一元夺宝、一元秒杀、刷单、A货、医疗、整形、美容、会所、酒吧、足浴、暴力、恐吓、色情、内容不雅、皮草、助考、商标注册.加群、加QQ或者加微信、贩卖个人信息、APP下载链接、申请好评返现、宣传短信通道、用户拉新、用户召回、运营商相关(营业厅，移动,联通，电信等)、党政议论、上访维权、迷信、八卦风水、及其他违反法律法规的内容。</div>
                      <div>4、不允许向非企业会员用户发送短信，例如针对邀请注册、邀请加入会员等短信内容。</div>
                      <div>5、短信中只允许有1个链接不允许有多个，且必须为抖音域内的M页格式短链接。</div>
                      <div>6、插入变量后请不要修改变量内容，否则无法匹配到相应的内容!</div>
                    </div>
                  </Balloon.Tooltip>
                  <Balloon.Tooltip
                    trigger={<Button text type='primary'>计费规则</Button>}
                    align={"t"}
                  >
                    <div className={style['tips-box']}>
                      <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                      <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                      <div>3.带标签短信以实际发送为准，由于变量值不同有可能超过默认字数。</div>
                      <div>4."签名"与营销短信类型时"{CONSTANTS.LZ_SMS_CANCEL_WORD}"包含在字数中。</div>
                    </div>
                  </Balloon.Tooltip>
                </div>
              </div>
              <div className={style['tips-title']}>
                <div className={style['red-text']}>
                  <span className={`iconfont icon-icon4-36`} style={{marginRight:'2px'}}/>
                  审核说明：短信模板由官方审核，审核时间: 4个小时内，工作时间：9:00~21:00（法定节假日延顺）
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style['right-box']}>
          <div className={style.phoneBox}>
            <div className={style.phoneImg}>
              <div
                className={style.previewMessage}
                dangerouslySetInnerHTML={{ __html: `${phoneMessage}` }}
              />
            </div>
            <div style={{
              marginLeft: '130px',
              width: '60px',
              marginTop: '15px',
              color: '#657180',
            }}
            >实时预览
            </div>
          </div>
        </div>
      </div>
      {
        goodsVisible &&
        <SelectGoods
          goodsDialog={goodsVisible}
          closeDialog={() => setGoodsVisible(false)}
          confirmSkuid={(v) =>{
            if(v.length>1) {
              LzMsg.error('一次只能选择一件商品!');
              return;
            } else if(v.length === 0) {
              LzMsg.error('请选择商品!');
              return;
            }else {
              setGoodsVisible(false);
              handleClickLink({name:'商品详情页',productId:v[0]});
            }
          }}
          skuIds={[]}
        />
      }
      {
        couponVisible &&
        <InsertCoupon
          couponVisible={couponVisible}
          setCouponVisible={()=>{
            setCouponVisible(false);
          }}
          couponConfirm={(v)=>{
            if(!v) {
              LzMsg.error('请输入优惠券ID!');
              return;
            }else {
              setCouponVisible(false);
              handleClickLink({name:'优惠券链接',couponId:v});
            }
          }}
        />
      }
    </LzDialog>
  );
}

export default CreateSmsTemplate;
